module.exports = __webpack_public_path__ + "media/images/Statistics-fb6ff19ccbcaa81f127c01897c7cba27.svg";